<div class="openCatalog" (mouseenter)="showBlock(true)" (mouseleave)="showBlock(false)">

  <button status="primary" nbButton i18n="@@Catalog" (click)="navToCatalog()">
    <nb-icon icon="list-outline"/>
    Каталог
  </button>

  <div [hidden]="!isShowBlock" class="menuCatalog">
    <div class="menuCatalog__content">
      <div class="list-menu">
        <div class="tree-container">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <mat-tree-node *matTreeNodeDef="let node">
                <ul style="width: 100%; padding: 0">
                <li class="mat-tree-node"
                  [ngClass]="{
          'root-level': treeControl.getLevel(node) === 2,
          'expanded': treeControl.isExpanded(node) && treeControl.getLevel(node) === 2
        }">

                <a matTreeNodePadding [matTreeNodePaddingIndent]="10"
                   class="noDecoration"
                   matTreeNodeToggle
                   queryParamsHandling="merge"
                   (click)="setId(node.id)"
                   [routerLink]="['/catalog']"
                   [queryParams]="{catalog_id: node.id,page: null}"
                >
                  {{ node.header }}
                  <span *ngIf="node.productCount > 0">{{ node.productCount?.toLocaleString() }}</span>
                </a>

                <ng-container *ngIf="!node.lastLevel">
                  <button matTreeNodeToggle>
                    <nb-icon [icon]=" treeControl.isExpanded(node) ? 'chevron-up-outline':'chevron-down-outline'"
                             [style.color]="treeControl.isExpanded(node) ? 'var(--color-icon-expanded)' : 'var(--color-primary)'"/>
                  </button>
                  <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                </ng-container>

              </li>
                </ul>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>
  </div>
</div>
